import './HomePage.scss';
import { AnimatedNumber } from '../../Components/Text/AnimatedNumber/AnimatedNumber';
import VideoTitle from '../../Components/VideoComponents/VideoTitle/VideoTitle';
import "../../i18n";
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import Button2 from '../../Components/Buttons/SimpleButton/Button_2/Button2';
import { AngledBackgroundSection } from '../../Components/Text/AngledBackgroundTextSection/New version/AngledBackgroundSection';
import { FaAngleRight, FaArrowRight } from 'react-icons/fa';
import Map from '../../Components/Maps/map';
import { useEffect, useRef, useState } from "react";
import image1 from '../../Assets/images/LeVIVO/LeVIVO_Greenfield_Park/04-01A.jpeg'
import image2 from '../../Assets/images/LeVIVO/LeVIVO_Greenfield_Park/04-03.jpeg'
import logo from '../../Assets/images/Logo/SIMDEV_Logo_NoBackground.png'

export default function Home() {
  const { t } = useTranslation();
  const navigate = useNavigate()

  const handleClickfunc = async () => {
    navigate('/projets');
  }

  const contactRef = useRef<HTMLDivElement | null>(null);
  const [contactVisible, setContactVisible] = useState(false);

  const skillsRef = useRef<HTMLDivElement | null>(null);
  const [skillsVisible, setSkillsVisible] = useState(false);

  useEffect(() => {
    const el = contactRef.current;
    if (!el) return;

    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setContactVisible(true);
          obs.disconnect();
        }
      },
      { threshold: 0.25 }
    );

    obs.observe(el);
    return () => obs.disconnect();
  }, []);


  useEffect(() => {
    const el = skillsRef.current;
    if (!el) return;

    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setSkillsVisible(true);
          obs.disconnect();
        }
      },
      { threshold: 0.25 }
    );

    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <div>
      <div>
        <VideoTitle title={t("home.title.title")} subtitle={t("home.title.subtitle")} />
      </div>
      <div>
        <div className='page-section'>
          <div className='text-container-lg' style={{ marginTop: "5rem" }}>
            <h1>{t("home.description.title")}</h1>
            <div className='justify-text'>
              <div>
                {t("home.description.firstText")}
              </div>
              <div>
                {t("home.description.secondText")}
              </div>
            </div>
            <div style={{ textAlign: "center" }}>
              <div>

                <Button2 text={t("home.button.text")} OnClick={handleClickfunc} color="#0f1a2c" width='260px' />
              </div>
            </div>
          </div>
        </div>
        <div>
          <AngledBackgroundSection
            backgroundColor="#0f1a2c"
            pageColor="#ffffff"
            contentPaddingY={200}
            contentPaddingX={24}
            top={{ type: "wave", height: 75, waveFlipX: true }}
            bottom={{ type: "wave", height: 75, waveFlipX: true }}
          >
            <div className="stats-section">
              <h1 style={{ textAlign: "center", marginBottom: "5rem" }}>{t("home.stats.title.title")}</h1>
              <div className='circles-container'>
                <div className="circle-wrapper">
                  <AnimatedNumber num={446} delayInSecond={1} isDark={false} speed={1.5} durationInSecond={1} circle={true} text={t("home.stats.circles.first.text")} enableShadow={true} fontSize={35} height={250} width={250} animationDelay={1000} numTension={10}></AnimatedNumber>
                </div>
                <div className="circle-wrapper">
                  <AnimatedNumber num={723695} delayInSecond={2} speed={3} isDark={false} durationInSecond={1} circle={true} side_text={t("home.stats.circles.second.side-text")} text={t("home.stats.circles.second.text")} enableShadow={true} fontSize={35} height={250} width={250} animationDelay={2000} numTension={10}></AnimatedNumber>
                </div>
                <div className="circle-wrapper">
                  <AnimatedNumber num={519450} delayInSecond={3} speed={2.8} isDark={false} durationInSecond={1} circle={true} side_text={t("home.stats.circles.third.side-text")} text={t("home.stats.circles.third.text")} enableShadow={true} fontSize={35} height={250} width={250} animationDelay={3000} numTension={10}></AnimatedNumber>
                </div>
                <div className="circle-wrapper">
                  <AnimatedNumber num={15} delayInSecond={4} speed={1.3} isDark={false} durationInSecond={1} circle={true} side_text={t("home.stats.circles.fourth.side-text")} text={t("home.stats.circles.fourth.text")} enableShadow={true} fontSize={35} height={250} width={250} animationDelay={4000} numTension={10}></AnimatedNumber>
                </div>
              </div>
            </div>
          </AngledBackgroundSection>
        </div>
        {/* SKILLS / EXPERTISE SECTION */}
        <div
          ref={skillsRef}
          className={`skills-section ${skillsVisible ? "skills-section--visible" : ""}`}
        >
          <div className="text-container-lg">
            <h1 className="skills-title">{t("home.skills.title", "Notre expertise")}</h1>
            <p className="skills-subtitle">
              {t("home.skills.subtitle", "Deux pôles complémentaires pour livrer des projets solides, du plan à la production.")}
            </p>

            <div className="skills-grid">
              <button
                className="skill-card skill-card--dev"
                type="button"
                onClick={() => navigate("/construction")}
                style={{
                  backgroundImage: `url(${image1})`,
                }}
              >
                <div className="skill-card__overlay" />
                <div className="skill-card__content">
                  <h2 className="skill-card__title">{t("home.skills.dev.title")}</h2>
                  <p className="skill-card__text">
                    {t("home.skills.dev.subtitle")}
                  </p>
                  <div className="skill-card__cta">
                    <span>{t("home.skills.cta", "Découvrir")}</span>
                    <span className="skill-card__arrow"><FaArrowRight /></span>
                  </div>
                </div>
              </button>

              <button
                className="skill-card skill-card--mgmt"
                type="button"
                onClick={() => navigate("/gestion")}
                aria-label={t("home.skills.mgmt.aria", "Voir nos services de gestion")}
                style={{
                  backgroundImage: `url(${image2})`,
                }}
              >
                <div className="skill-card__overlay" />
                <div className="skill-card__content">
                  <h2 className="skill-card__title">{t("home.skills.mgmt.title")}</h2>
                  <p className="skill-card__text">
                    {t("home.skills.mgmt.subtitle")}
                  </p>
                  <div className="skill-card__cta">
                    <span>{t("home.skills.cta", "Découvrir")}</span>
                    <span className="skill-card__arrow"><FaArrowRight /></span>
                  </div>
                </div>
              </button>
            </div>
          </div>
        </div>
        <AngledBackgroundSection
          backgroundColor="#f5f7fb"
          pageColor="#ffffff"
          contentPaddingY={200}
          contentPaddingX={24}
          top={{ type: "wave", height: 75, waveFlipX: true }}
          bottom={{ type: "none" }}
        >
          <div
            ref={contactRef}
            className={`home-contact-section-container ${contactVisible ? "is-visible" : ""}`}
          >
            <div className="home-contact-panel home-contact-panel--info">
              <div className="home-contact-section-text">
                <div>
                  <img src={logo} alt='Simdev logo' className="home-contact-section-logo"></img>
                </div>
                <div style={{marginLeft:"10px"}}>
                  <h1>{t("home.contact.title")}</h1>
                  <h3>{t("home.contact.subtitle")}</h3>

                  <div className="home-contact-lines">
                    <div>{t("location.address")}</div>
                    <div>(514) 686-6868</div>
                    <div><a href="mailto:info@simdev.ca">info@simdev.ca</a></div>
                  </div>

                  <div className="home-contact-actions">
                    <p className="home-contact-btn" onClick={() => navigate("/nousrejoindre")}>
                      {t("home.contact.ctaEmail", "Vous pouvez nous rejoindre ici")} <FaAngleRight />
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="home-contact-panel home-contact-panel--map">
              <div className="home-map-frame">
                <Map />
              </div>
            </div>
          </div>
        </AngledBackgroundSection>
      </div>
    </div>
  );
}


